import { InjectionToken } from "@angular/core";

export const POPOUT_MODAL_DATA = new InjectionToken<any>("POPOUT_MODAL_DATA");
export const POPOUT_WINDOW_REF = new InjectionToken<Window>("WINDOW_REF");

export let POPOUT_MODALS = {};
